import { POSTHOG_CLIENT_CONFIG, type PrePeersPostHogClientConfig } from '~/constants/posthog'

/**
 * Le module `@posthog/nuxt` initialise posthog-js avec `api_host: host` puis spread
 * `posthogClientConfig` — ce dernier n'est pas toujours sérialisé côté client.
 * Ce plugin (enforce: pre) garantit le chemin proxy avant l'init du SDK.
 */
export default defineNuxtPlugin({
  name: 'posthog-proxy-config',
  enforce: 'pre',
  setup(): void {
    const config = useRuntimeConfig()
    const existing: Partial<PrePeersPostHogClientConfig> =
      (config.public.posthogClientConfig as Partial<PrePeersPostHogClientConfig> | undefined) ?? {}

    config.public.posthogClientConfig = {
      ...existing,
      ...POSTHOG_CLIENT_CONFIG,
    }
  },
})
